(function() {
'use strict';

angular.module('quote')
    .config(quoteConfig);

    function quoteConfig($routeProvider) {
        if (!TRPCONFIG.Domain.QuoteEnabled) {
            return;
        }

        if (TRPCONFIG.Domain.isAgentMode && TRPCONFIG.Domain2.AllowAgentManageQuote) {
            $routeProvider.when('/quote/manage/:quoteRef?/:quoteNo?', {
                templateUrl: 'partials/quote/index',
                controllerAs: 'qc',
                controller: 'Quote'
            });
            $routeProvider.when('/quote/advancedSearch', {
                templateUrl: 'partials/quote/quoteadvancedsearch'
            });
        } else {
            $routeProvider.when('/quote/manage/:quoteRef?/:quoteNo?', {
                templateUrl: 'partials/quote/indexPublic',
                controllerAs: 'qp',
                controller: 'QuotePublic'
            });
        }

        /* Reverting these urls into existence due to v1 - dont use them, use the urls they redirect to instead */
        $routeProvider.when('/quote/manageyourquote/login', {
            redirectTo: '/quote/manage/'
        });
        $routeProvider.when('/quote/manageyourquote/details/:quoteRef/:quoteNo', {
            redirectTo: '/quote/manage/:quoteRef/:quoteNo'
        });
    }
})();
